import React from "react";
import './c17_altri_componenti.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RSC from "react-scrollbars-custom";
import {insertHtml} from "../../utils/dom";


class AltriComponenti extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            dataIndex: 0
        };

        this.requireInternationalization = true;
    };

    showContent = (dataIndex) => {
        if (dataIndex < 9) {
            this.setState({
                isHidden: !this.state.isHidden,
                dataIndex: dataIndex
            });
        } else {
            this.setState({
                isHidden: !this.state.isHidden,
                dataIndex: parseInt(dataIndex, 10) - 2
            });
        }
    };

    showContentDesktop = (dataIndex) => {
        this.setState({
            isHidden: !this.state.isHidden,
            dataIndex: dataIndex
        });
    };

    internationalComponentRender(data, t) {
        let dataArray = data.item;
        let reminder = 4 - (dataArray.length % 4);
        let i;
        if (dataArray.length % 4 > 0) {
            for (i = 0; i < reminder; i++) {
                dataArray.push({});
            }
        }

        const firstArray = dataArray.slice(0, 8);
        const secondArray = dataArray.slice(8);

        return (
            !isMobileOnly ?
                <div id="altri-componenti"  className="c17-altri-componenti auto-margins">
                    <div className="altri-componenti-title">{data.title}</div>
                    <div className="container">
                        <div className="row">
                            {dataArray.map((persona, index) => (
                                <>
                                    <div key={index} className="col-sm-3 altri-componenti-card">
                                        {persona.name ? <div className="altri-componenti-name">{persona.name}</div> : null}
                                        {persona.position ? <div className="altri-componenti-position">{persona.position}</div> : null}
                                        {persona.name &&
                                            <div className="altri-componenti-btn" onClick={() => this.showContentDesktop(index)}>
                                                {t("C17 button view profile")}
                                            </div>
                                        }
                                    </div>
                                    {!this.state.isHidden && index === this.state.dataIndex - (this.state.dataIndex % 4) + 3 &&
                                        <div className="altri-componenti-modal">
                                            <button className="altri-componenti-modal-btn" onClick={() => this.showContentDesktop(0)}>
                                                &times;
                                            </button>
                                            <div className="altri-componenti-modal-text"{...insertHtml(data.item[this.state.dataIndex].bio)} />
                                            {data.item[this.state.dataIndex].contacts &&
                                                <div className="altri-componenti-modal-contact">{data.item[this.state.dataIndex].contacts}</div>
                                            }
                                            {data.item[this.state.dataIndex].email &&
                                                <div className="altri-componenti-modal-email">
                                                    <a href={'mailto:' + data.item[this.state.dataIndex].email}>{data.item[this.state.dataIndex].email}</a>
                                                </div>
                                            }
                                        </div>
                                    }
                                </>
                            ))}
                        </div>
                    </div>
                </div> :
                <div id="altri-componenti-mob" className="c17-altri-componenti">
                    <div className="altri-componenti-title">Altri componenti</div>
                    <RSC className="scrollbar-container ScrollbarsCustom trackXVisible">
                        <div className="container">
                            <div className="row">
                                {firstArray.map((persona, index) => (
                                    <div key={index} className="col-sm-3 altri-componenti-card">
                                        <div className="altri-componenti-name">{persona.name}</div>
                                        <div className="altri-componenti-position">{persona.position}</div>
                                        <div className="altri-componenti-btn" onClick={() => this.showContent(index)}>
                                            {t("C17 button view profile")}
                                        </div>
                                    </div>
                                ))}
                                {secondArray.map((persona, index) => (
                                    <div key={index} className="col-sm-3 altri-componenti-card">
                                        <div className="altri-componenti-name">{persona.name}</div>
                                        <div className="altri-componenti-position">{persona.position}</div>
                                        <div className="altri-componenti-btn" onClick={() => this.showContent(index + 10)}>
                                            {t("C17 button view profile")}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </RSC>
                    {!this.state.isHidden &&
                        <div className="altri-componenti-modal">
                            <button className="altri-componenti-modal-btn" onClick={() => this.showContent(0)}>
                                &times;
                            </button>
                            <div className="altri-componenti-modal-name">{data.item[this.state.dataIndex].name}</div>
                            <div className="altri-componenti-modal-position">{data.item[this.state.dataIndex].position}</div>
                            <div className="altri-componenti-modal-text" {...insertHtml(data.item[this.state.dataIndex].bio)} />
                            <div className="altri-componenti-modal-contact">{data.item[this.state.dataIndex].contacts}</div>
                            <div className="altri-componenti-modal-email">
                                <a href={'mailto:' + data.item[this.state.dataIndex].email}>{data.item[this.state.dataIndex].email}</a>
                            </div>
                        </div>
                    }
                </div>
        )
    }
}

export default AltriComponenti;
